import ttt from '@xing-com/ticktricktrack';

const CHANNEL = 'wbm/Companies';

export const trackPage = (pageName: $TSFixMe, extraProps = {}) => {
  ttt.pageview(
    CHANNEL,
    `${CHANNEL}/${pageName}`,
    ttt.assign({}, ttt.baseData, extraProps)
  );
};

export const trackEvent = (
  eventName: $TSFixMe,
  interactionType: $TSFixMe,
  extraProps = {}
) => {
  ttt.event(eventName, {
    [eventName]: 1,
    PropInteractionType: interactionType,
    ...extraProps,
  });
};

export const trackAction = (actionName: $TSFixMe, contextData: $TSFixMe) => {
  ttt.event('PropTrackAction', { PropTrackAction: actionName, ...contextData });
};

// export const withPageTracking = createTrackingHoc('pageview');

const addParamToUrl = (url: $TSFixMe, key: $TSFixMe, value: $TSFixMe) => {
  return `${url}${url.split('?')[1] ? '&' : '?'}${key}=${value}`;
};

export const addTrackingParamsToURL = ({ url, params = {} }: $TSFixMe) => {
  let urlWithTracking = url;

  Object.entries(params).forEach(([paramKey, paramValue]) => {
    urlWithTracking = addParamToUrl(url, paramKey, paramValue);
  });

  return urlWithTracking;
};
